import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { apiPost, operationsClient } from '@/lib/api';
import { opsProposalEndpoints } from '@/lib/api/endpoints';
import { opsProposalKeys } from '@/lib/queryKeys';
import type { Proposal } from '@/types/proposal';

export interface FollowUpProposalInput {
  id: string;
  followUpDate: string;
}

export function useFollowUpProposal() {
  const queryClient = useQueryClient();

  return useApiMutation<Proposal, FollowUpProposalInput>({
    mutationFn: ({ id, followUpDate }) =>
      apiPost<Proposal>(operationsClient, opsProposalEndpoints.followUp(id), { followUpDate }),
    onSuccess: (data) => {
      void queryClient.invalidateQueries({ queryKey: opsProposalKeys.lists() });
      void queryClient.invalidateQueries({ queryKey: opsProposalKeys.detail(data.id) });
      toast.success('Follow-up scheduled');
    },
  });
}
